var React = require('react');

function ChevronSolidDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.5 3.5L0 0H7L3.5 3.5Z","fill":"#929088"}));
}

ChevronSolidDown.defaultProps = {"width":"7","height":"4","viewBox":"0 0 7 4","fill":"none"};

module.exports = ChevronSolidDown;

ChevronSolidDown.default = ChevronSolidDown;
